import ApiService from "./ApiService";

// export async function apiGetApplicationList(params) {
//   return ApiService.fetchData({
//     url: "/user/student-applications",
//     method: "get",
//     params,
//   });
// }
export async function apiGetApplicationList(params, options = {}) {
  return ApiService.fetchData({
    url: "/user/application-requests",
    method: "get",
    params,
    ...options,
  });
}

// export async function apiApplyToIntake(data) {
//   return ApiService.fetchData({
//     url: `/user/student-applications`,
//     method: "post",
//     data,
//   });
// }
export async function apiApplyToIntake(data, options = {}) {
  return ApiService.fetchData({
    ...options,
    url: `/user/application-requests`,
    method: "post",
    data,
  });
}

export async function apiGetApplicationDetails(courseId, intakeId, options = {}) {
  return ApiService.fetchData({
    ...options,
    url: `/user/student-applications/status?courseId=${courseId}&intakeId=${intakeId}`,
    method: "get",
  });
}

export async function apiGetTimeline(params) {
  return ApiService.fetchData({
    url: `/user/student-applications/timeline?applicationId=${params.applicationId}`,
    method: "get",
    // params,
  });
}

export async function getApplicationLogs(params, options = {}) {
  return ApiService.fetchData({
    ...options,
    url: `/user/student-applications/activity-log`,
    method: "get",
    params,
  });
}
